import { useMutation } from "@tanstack/react-query"
import { createContactRequest } from "@/data/requests/staticRequests"

export const useCreateContactRequestMutation = () =>
  useMutation({ mutationFn: createContactRequest })
